export const errorMessages = {
  /* Internal */
  statusCode: 'Status code:',
  httpError: 'There was an HTTP error.',
  typeError: 'There was a Type error.',
  generalError: 'There was a general error.',
  failedToCatchError: 'Nobody threw an error but something happened!',
  authorisation: 'You are not authorised to perform this action',
  notFound: 'The resource you were looking for could not be found',
  unhandledException: 'An unexpected error has occurred and has been reported.',
};
